<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <div>
          <h1>Create new PaRama Course</h1>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <!-- <div class="d-flex justify-end">
          <div>
            <v-btn icon id="no-background-hover" to="/blog" class="">
              <span class="group pa-2">
                <v-icon medium>mdi-keyboard-backspace</v-icon>
              </span>
            </v-btn>
            
          </div>
        </div> -->
      </v-col>
    </v-row>
    <div class="my-9">
      <v-tabs v-model="tab" slider-color="transparent">
        <div
          class="d-flex"
          style="width: 100%; background: rgba(236, 241, 242, 1)"
        >
          <v-tab
            ripple
            href="#tab-1"
            @click="
              () => {
                this.tab == 'tab-1';
                this.continuebtn = true;
              }
            "
            ><span class="tabs_style text_style"> Content </span></v-tab
          >
          <v-icon class="mr-5">mdi-chevron-right</v-icon>
          <v-tab
            ripple
            href="#tab-2"
            @click="
              () => {
                this.tab == 'tab-2';
                this.continuebtn = true;
              }
            "
          >
            <span class="tabs_style text_style"> Settings </span> </v-tab
          ><v-icon class="mr-5">mdi-chevron-right</v-icon>
          <v-tab
            ripple
            href="#tab-3"
            @click="
              () => {
                this.tab == 'tab-3';
                this.continuebtn = true;
              }
            "
          >
            <span class="tabs_style text_style"> Set Up </span>
          </v-tab>
          <v-icon class="mr-5">mdi-chevron-right</v-icon>
          <v-tab
            ripple
            href="#tab-4"
            @click="
              () => {
                this.tab == 'tab-4';
                this.continuebtn = true;
              }
            "
          >
            <span class="tabs_style text_style"> Royalties </span> </v-tab
          ><v-icon class="mr-5">mdi-chevron-right</v-icon>
          <v-tab
            ripple
            href="#tab-5"
            @click="
              () => {
                this.tab == 'tab-5';
                this.continuebtn = false;
              }
            "
          >
            <span class="tabs_style text_style"> Publish </span>
          </v-tab>
        </div>
        <v-tab-item value="tab-1">
          <v-card-text>
            <div style="margin: 0 8.9vw">
              <v-text-field
                single-line
                flat
                style="font-size: 2rem; max-height: initial !important"
                v-model="form.Title"
                label="Write you title here"
                height="60"
                hide-details=""
                :error="$v.form.Title.$error"
              ></v-text-field>
              <div class="red--text" v-if="$v.form.Title.$error">
                Title is required
              </div>
              <v-textarea
                single-line
                counter
                maxlength="250"
                flat
                class="mt-4"
                v-model="form.subHeading"
                :error="$v.form.subHeading.$error"
                hide-details=""
                label="Write sub-heading description here "
              ></v-textarea>
              <div class="red--text" v-if="$v.form.subHeading.$error">
                Description is required
              </div>

              <div>
                <blogimageuploader-component
                  @SetBanner="SetBanner"
                  @SetThumbnail="SetThumbnail"
                  @SetImage1="SetImage1"
                  @SetImage2="SetImage2"
                  @SetImage3="SetImage3"
                />
                <div
                  class="red--text"
                  v-if="$v.form.Banner.$error || $v.form.Thumbnail.$error"
                >
                  Thumbnail and Banner are required
                </div>
              </div>

              <v-select
                class="my-9"
                outlined
                v-model="form.filterCategory"
                :items="filterCategoryArray"
                dense
                hide-details
                label="Category"
                multiple
                persistent-hint
                :menu-props="{ maxHeight: '400' }"
              ></v-select>
              <div class="mt-3">
                <span> <b> Course Description </b></span>
              </div>
              <div class="my-4">
                <blogtextediter-component
                  @CourseDescription="CourseDescription"
                />
              </div>
              <!-- <div class="red--text" v-if="$v.form.Content.$error">
                Description is required
              </div> -->
              <v-card outlined>
                <v-row class="pa-4">
                  <v-col cols="12" md="7">
                    <v-text-field
                      single-line
                      v-model="form.InstructorName"
                      label="Instructor name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5">
                    <div class="ml-2 my-2">
                      <span> <b> Instructor headshot (optional)</b> </span>
                    </div>
                    <div class="ml-2 my-2">
                      <span>(300 x 400px) </span>
                    </div>
                    <div>
                      <div style="overflow: hidden">
                        <v-card
                          @click="UploadInstructorImage"
                          max-width="300"
                          flat
                          color="transparent"
                          v-model="svgBackground2"
                          class="svgBackgroundSection"
                          style="overflow: hidden"
                          v-if="form.InstructorImage == null"
                        >
                          <div style="height: 100%; position: relative">
                            <CameraBorderBoxSvg></CameraBorderBoxSvg>
                          </div>
                        </v-card>
                        <v-card v-model="UploadedImage2" v-else>
                          <v-img
                            :src="form.InstructorImage"
                            ref="RefInstructorImage"
                            height="300"
                            width="400"
                            contain
                          ></v-img>
                        </v-card>
                      </div>

                      <input
                        type="file"
                        accept="image/png, image/gif, image/jpeg"
                        style="display: none"
                        ref="RefInstructorImage"
                        @change="SetInstructorImage"
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-card>
              <div class="mt-3">
                <span> <b> Instructor bio </b></span>
              </div>
              <div class="my-4">
                <blogtextediter-component @InstructorBio="SetInstructorBio" />
              </div>
              <div>
                <v-btn color="primary" text @click="SeeSecondInstructor = true">
                  <div class="text_style">+ Add second Instructor</div>
                </v-btn>
              </div>
              <div class="my-2">
                <v-btn
                  color="primary"
                  text
                  @click="SeePrimaryTranslator = true"
                >
                  <div class="text_style">+ Add translator</div>
                </v-btn>
              </div>
              <div>
                <v-btn color="primary" text @click="SeeSecondTranslator = true">
                  <div class="text_style">+ Add second translator</div>
                </v-btn>
              </div>
              <!---------------Second Instructor----------------------->
              <v-card outlined class="my-3" v-if="SeeSecondInstructor">
                <v-row class="pa-4">
                  <v-col cols="12">
                    <div class="d-flex justify-space-between mb-2">
                      <span> <b>Second Instructor bio </b></span>
                      <v-icon
                        color="red"
                        class="cursor-pointer"
                        @click="SeeSecondInstructor = false"
                        >mdi-close</v-icon
                      >
                    </div>
                    <div style="width: 100%">
                      <blogtextediter-component @SetContent="SetContent" />
                    </div>
                  </v-col>
                </v-row>
              </v-card>
              <!---------------Translator----------------------->
              <v-card outlined class="my-3" v-if="SeePrimaryTranslator">
                <v-row class="pa-4">
                  <v-col cols="12" md="7">
                    <v-text-field single-line label="Translator"></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="5"
                    class="d-flex justify-space-between align-start"
                  >
                    <div>
                      <div class="ml-2 my-2">
                        <span> <b> Translator headshot (optional)</b> </span>
                      </div>
                      <div class="ml-2 my-2">
                        <span>(300 x 400px) </span>
                      </div>
                      <div>
                        <div style="overflow: hidden" @click="UploadImgfour">
                          <v-card
                            max-width="300"
                            flat
                            color="transparent"
                            v-model="svgBackground4"
                            class="svgBackgroundSection"
                            style="overflow: hidden"
                            v-if="Src4 == null"
                          >
                            <div style="height: 100%; position: relative">
                              <CameraBorderBoxSvg></CameraBorderBoxSvg>
                            </div>
                          </v-card>
                          <v-card v-model="UploadedImagefour" v-else>
                            <v-img
                              :src="Src4"
                              ref="Image4"
                              max-height="300"
                              max-width="400"
                              contain
                            ></v-img>
                          </v-card>
                        </div>

                        <input
                          type="file"
                          accept="image/png, image/gif, image/jpeg"
                          style="display: none"
                          ref="Img4"
                          @change="SetImage4"
                        />
                      </div>
                    </div>
                    <v-icon
                      color="red"
                      class="cursor-pointer"
                      @click="SeePrimaryTranslator = false"
                      >mdi-close</v-icon
                    >
                  </v-col>
                </v-row>
              </v-card>
              <!---------------Second Translator----------------------->
              <v-card outlined class="my-3" v-if="SeeSecondTranslator">
                <v-row class="pa-4">
                  <v-col cols="12" md="7">
                    <v-text-field
                      single-line
                      label="Second Translator"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="5"
                    class="d-flex justify-space-between align-start"
                  >
                    <div>
                      <div class="ml-2 my-2">
                        <span> <b> Translator headshot (optional)</b> </span>
                      </div>
                      <div class="ml-2 my-2">
                        <span>(300 x 400px) </span>
                      </div>
                      <div>
                        <div style="overflow: hidden" @click="UploadImgfive">
                          <v-card
                            max-width="300"
                            flat
                            color="transparent"
                            v-model="svgBackground5"
                            class="svgBackgroundSection"
                            style="overflow: hidden"
                            v-if="Src5 == null"
                          >
                            <div style="height: 100%; position: relative">
                              <CameraBorderBoxSvg></CameraBorderBoxSvg>
                            </div>
                          </v-card>
                          <v-card v-model="UploadedImagefive" v-else>
                            <v-img
                              :src="Src5"
                              ref="Image5"
                              max-height="300"
                              max-width="400"
                              contain
                            ></v-img>
                          </v-card>
                        </div>

                        <input
                          type="file"
                          accept="image/png, image/gif, image/jpeg"
                          style="display: none"
                          ref="Img5"
                          @change="SetImage5"
                        />
                      </div>
                    </div>
                    <v-icon
                      color="red"
                      class="cursor-pointer"
                      @click="SeeSecondTranslator = false"
                      >mdi-close</v-icon
                    >
                  </v-col>
                </v-row>
              </v-card>
              <div>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.CourseStartDate"
                      label="Course Start Date (Optional)"
                      prepend-icon="mdi-calendar"
                      readonly
                      class="mt-6"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.CourseStartDate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu.save(form.CourseStartDate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
              <!-- <div class="my-6">
                <blogtextediter-component @SetContent="SetContent" />
              </div> -->
            </div>
          </v-card-text>
        </v-tab-item>
        <v-tab-item value="tab-2">
          <v-card-text>
            <div style="margin: 0 8.9vw">
              <!----------------------card 1-------------------------------------->
              <v-card
                class="my-6 pa-9"
                flat
                color="#FBFBFF"
                style="border: 1px solid #dee3ef"
              >
                <div>
                  <span class="h1_tab2">Course Fee </span>

                  <v-card class="mt-6" flat>
                    <v-select
                      class="pt-1"
                      multiple
                      label=""
                      v-model="form.CourseStartDate"
                      dense
                      single-line
                      outlined
                      hide-details=""
                    ></v-select>
                  </v-card>
                </div>
                <div>
                  <span class="h1_tab2">Permissions </span>

                  <v-card class="mt-6" flat>
                    <v-select
                      class="pt-1"
                      multiple
                      :items="permissionsArray"
                      v-model="form.selectedPermissions"
                      label="Permissions"
                      dense
                      single-line
                      outlined
                      hide-details=""
                    ></v-select>
                  </v-card>
                </div>
                <div class="my-8">
                  <span class="h1_tab2">CEUs </span>
                  <!-- <span style="display: block"
                    >Lorem ipsum dolor sit amet consectetur adropising lorem
                    ipsum dlor sit amet
                  </span> -->
                  <v-card class="mt-6" flat>
                    <v-text-field
                      label="16"
                      single-line
                      dense
                      v-model="form.CEUs"
                      hide-details
                      outlined
                    ></v-text-field>
                  </v-card>
                </div>

                <div class="my-8">
                  <span class="h1_tab2"> Display Order </span>
                  <!-- <span style="display: block"
                    >Lorem ipsum dolor sit amet consectetur adropising
                  </span> -->
                  <v-card class="mt-6" flat>
                    <v-select
                      class="pt-1"
                      :items="VisibilityArray"
                      label="Display Order Number"
                      dense
                      single-line
                      v-model="form.DisplayOrder"
                      outlined
                      hide-details=""
                    ></v-select>
                  </v-card>
                </div>
                <div>
                  <span class="h1_tab2">Level </span>
                  <!-- <span style="display: block"
                    >Lorem ipsum dolor sit amet consectetur adropising
                  </span> -->
                  <v-card class="mt-6" flat>
                    <v-select
                      v-model="form.level"
                      class="pt-1"
                      :items="LevelsArray"
                      menu-props="auto"
                      dense
                      single-line
                      outlined
                      hide-details=""
                      return-object
                    ></v-select>
                  </v-card>
                </div>
                <div class="my-8">
                  <span class="h1_tab2">Language </span>
                  <!-- <span style="display: block"
                    >Lorem ipsum dolor sit amet consectetur adropising
                  </span> -->
                  <v-card class="mt-6" flat>
                    <v-select
                      class="pt-1"
                      v-model="form.selectedLanguage"
                      :items="LanguageArray"
                      label="Visible (default)"
                      dense
                      single-line
                      outlined
                      hide-details=""
                    ></v-select>
                  </v-card>
                </div>
                <div class="mt-4">
                  <v-row>
                    <v-col cols="12" md="4" class="pb-0">
                      <span class="h1_tab2">Member Discount </span>

                      <v-card class="mt-4" flat>
                        <v-select
                          class="pt-1"
                          :items="MemberArray"
                          label="Member Level"
                          dense
                          single-line
                          outlined
                          hide-details=""
                        ></v-select>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="4" class="pb-0">
                      <span class="h1_tab2"> </span>

                      <v-card class="mt-12" flat>
                        <v-text-field
                          class=" "
                          label="USD Percentage off"
                          dense
                          single-line
                          outlined
                          hide-details=""
                        ></v-text-field>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
                <div class="my-3">
                  <v-row
                    v-for="(div, index) in divs"
                    :key="div.id"
                    :div="(div = index)"
                  >
                    <v-col cols="12" md="4">
                      <v-card class="mt-2" flat>
                        <v-select
                          class="pt-1"
                          :items="MemberArray"
                          label="Member Level"
                          dense
                          single-line
                          outlined
                          hide-details=""
                        ></v-select>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-card class="mt-3 d-flex align-center" flat>
                        <v-text-field
                          class=" "
                          label="USD Percentage off"
                          dense
                          single-line
                          outlined
                          hide-details=""
                        ></v-text-field>
                        <v-icon
                          style="cursor: pointer"
                          @click="RemoveRowMembershipDiscount(div.id)"
                          color="red"
                          class="ml-7"
                          >mdi-delete</v-icon
                        >
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
                <v-btn
                  color="primary"
                  text
                  style="text-transform: none"
                  @click="addRow"
                >
                  + Add Member Level
                </v-btn>
                <div class="mt-6">
                  <span class="h1_tab2">Free with account creation? </span>
                  <v-radio-group v-model="form.FeeAccountCreation" row>
                    <v-radio value="Yes" class="mr-7">
                      <template v-slot:label>
                        <div class="mt-2">Yes</div>
                      </template>
                    </v-radio>
                    <v-radio value="No">
                      <template v-slot:label>
                        <div class="mt-2">No</div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </div>
                <div class="">
                  <span class="h1_tab2"
                    >Expires 1 year after purchase date?
                  </span>
                  <v-radio-group v-model="form.AfterPurchaseDate" row>
                    <v-radio value="valueYes" class="mr-7">
                      <template v-slot:label>
                        <div class="mt-2">Yes</div>
                      </template>
                    </v-radio>
                    <v-radio value="valueNo">
                      <template v-slot:label>
                        <div class="mt-2">No</div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </div>
                <div>
                  <span class=""
                    >Note, a later feature will be to incorporate subscriptions
                    which gives unlimited use with no expiration until the
                    subscription is cancelled.
                  </span>
                </div>
              </v-card>

              <!----------------------card 3-------------------------------------->
              <v-card
                class="my-6 pa-9"
                flat
                color="#FBFBFF"
                style="border: 1px solid #dee3ef"
              >
                <span class="h1_tab2">Prerequisites</span>
                <!-- <span style="display: block"
                  >Lorem ipsum dolor sit amet consectetur adropising
                </span> -->
                <div>
                  <v-btn
                    class="mt-9"
                    color="primary"
                    depressed
                    @click="prerequisitesDialog = true"
                  >
                    <span class="text_style">Choose prerequisites</span>
                  </v-btn>
                </div>

                <v-dialog v-model="prerequisitesDialog" max-width="700">
                  <v-card rounded="4" class="pa-11">
                    <v-card-title class="text-h5 px-5 mb-6">
                      Choose Prerequisites
                    </v-card-title>
                    <div class="pl-5" v-show="prerequisitescourses">
                      Choose Prerequisites
                    </div>
                    <div v-show="prerequisites">
                      <div class="d-flex" style="width: 500px">
                        <span class="px-5"> ( </span>

                        <v-select
                          outlined
                          color="primary"
                          dense
                          style="width: 10px"
                        ></v-select>

                        <span class="px-5"> or </span>

                        <v-select
                          outlined
                          color="primary"
                          dense
                          style="width: 10px"
                        ></v-select>

                        <span class="px-5"> )</span>
                        and
                      </div>
                    </div>

                    <div class="mt-10 pl-5">
                      <v-divider style="height: 1px; background: #c4c4c4">
                      </v-divider>
                      <v-card dark class="py-3 px-9" rounded="4" width="367px">
                        <v-btn color="primary" @click="Showprerequisites()"
                          ><span class="text_style">Course</span></v-btn
                        >
                        <span style="color: white" class="px-7">
                          ( )<span class="px-9"> or </span>and
                        </span>
                      </v-card>
                    </div>

                    <v-card-actions class="mt-4">
                      <v-spacer></v-spacer>

                      <v-btn
                        color="#5F6062"
                        text
                        @click="prerequisitesDialog = false"
                      >
                        Canel
                      </v-btn>

                      <v-btn
                        color="primary"
                        class="px-10 py-5"
                        depressed
                        @click="prerequisitesDialog = false"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-card>
              <!----------------------card 4-------------------------------------->
              <v-card
                class="my-6 pa-9"
                flat
                color="#FBFBFF"
                style="border: 1px solid #dee3ef"
              >
                <div>
                  <span class="h1_tab2">Currency</span>
                  <span style="display: block"
                    >Instructor is given access to the course to edit, add
                    lessons/panels, change content
                  </span>
                  <v-card class="mt-6" flat>
                    <v-select
                      v-model="form.Currency"
                      class="pt-1"
                      :items="CurrencyTypeArray"
                      menu-props="auto"
                      dense
                      single-line
                      outlined
                      hide-details=""
                      return-object
                    ></v-select>
                  </v-card>
                </div>
                <div class="mt-8">
                  <span class="h1_tab2">Price </span>
                  <!-- <span style="display: block"
                    >Lorem ipsum dolor sit amet consectetur adropising lorem
                    ipsum dlor sit amet
                  </span> -->
                  <v-card class="mt-6" flat>
                    <v-text-field
                      label="Price"
                      single-line
                      v-model="form.coursePrice"
                      outlined
                      hide-details
                      dense
                    ></v-text-field>
                  </v-card>
                  <v-checkbox v-model="form.FreeCourseCheckBox">
                    <template v-slot:label>
                      <div class="mt-2">This course is FREE</div>
                    </template>
                  </v-checkbox>
                </div>
              </v-card>
              <v-card
                class="my-2 pa-9"
                flat
                color="#FBFBFF"
                style="border: 1px solid #dee3ef"
              >
                <span class="h1_tab2">Add Video URL </span>

                <v-card class="mt-6" flat>
                  <v-text-field
                    label="(Youtube Link)"
                    single-line
                    outlined
                    v-model="form.VideoUrl"
                    hide-details
                    dense
                  ></v-text-field>
                </v-card>
                <!-----------------for multiple file uploader---------------------------------------------->
                <div class="mt-3">
                  <span class="h1_tab2">Waiver </span>
                </div>
                <v-card outlined height="100" class="px-6 mt-4">
                  <div class="d-flex align-center" style="height: 100%">
                    <v-chip
                      color="primary"
                      @click:close="closechip(i)"
                      close
                      outlined
                      pill
                      :key="i"
                      v-for="(c, i) in UploadedfileName"
                      >{{ c.name }}</v-chip
                    >
                  </div>
                </v-card>
                <div>
                  <v-btn
                    class="text_style my-4 px-11"
                    color="primary"
                    outlined
                    @click="onButtonClick"
                    >Upload document</v-btn
                  >
                  <input
                    ref="uploader"
                    class="d-none"
                    multiple
                    type="file"
                    accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
                      text/plain, application/pdf,"
                    @change="onFileChanged"
                  />
                </div>
                <!-----------------optional Waiver--------------------------------------->
                <div class="mt-4">
                  <span class="h1_tab2"
                    >Waiver 2
                    <span
                      style="font-size: 20px; color: #636364; font-weight: 400"
                    >
                      (optional)</span
                    >
                  </span>
                  <!-- <span style="display: block"
                    >Lorem ipsum dolor sit amet consectetur adropising lorem
                    ipsum dlor sit amet
                  </span> -->

                  <v-card outlined height="100" class="px-6 mt-4">
                    <div class="d-flex align-center" style="height: 100%">
                      <v-chip
                        color="primary"
                        @click:close="closechip2(i)"
                        close
                        outlined
                        pill
                        :key="i"
                        v-for="(c, i) in UploadedfileNametwo"
                        >{{ c.name }}</v-chip
                      >
                    </div>
                  </v-card>
                  <div>
                    <v-btn
                      class="text_style my-4 px-11"
                      color="primary"
                      outlined
                      @click="onButtonClick2"
                      >Upload document</v-btn
                    >
                    <input
                      ref="uploader2"
                      class="d-none"
                      multiple
                      type="file"
                      accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
                      text/plain, application/pdf,"
                      @change="onFileChanged2"
                    />
                  </div>
                </div>
              </v-card>

              <!----------------------card 5-------------------------------------->
              <v-card
                class="my-2 pa-9"
                flat
                color="#FBFBFF"
                style="border: 1px solid #dee3ef"
              >
                <span class="h1_tab2">Related courses 3/4 </span>
                <!-- <span style="display: block"
                  >Connect related content from your News to give readers more
                  to explore.
                </span> -->
                <v-row class="pa-2">
                  <v-col
                    cols="12"
                    md="4"
                    v-for="(item, index) in relatedContentArray"
                    :key="index"
                  >
                    <div>
                      <v-card
                        class="mb-12"
                        outlined
                        style="border: 1px solid rgba(8, 8, 22, 0.15)"
                        flat
                      >
                        <v-img height="250" :src="item.img"></v-img>
                        <div class="pr-10">
                          <v-card
                            class=""
                            rounded="circle"
                            color="white"
                            flat
                            style="position: absolute; top: 7px; right: 7px"
                          >
                            <v-icon
                              close
                              color="primary"
                              @click="close = close(index)"
                              >mdi-close</v-icon
                            >
                          </v-card>
                        </div>
                        <div class="pa-4">
                          <span class="content_span"
                            >Lorem ipsum dolor sit amet consectetur
                            adropising</span
                          >
                          <div>
                            <span class="content_date">September 23, 2021</span>
                          </div>
                          <div class="mt-3">
                            <v-chip color="#E2F2E6" class="px-6">
                              <span class="content_chip">
                                Published
                              </span></v-chip
                            >
                          </div>
                        </div>
                      </v-card>
                    </div>
                  </v-col>
                </v-row>

                <v-btn
                  class="px-6 text_style"
                  outlined
                  style="
                    border: 1px solid rgba(8, 8, 22, 0.15);
                    color: rgba(34, 34, 34, 0.7);
                  "
                  >Add Related course
                </v-btn>
              </v-card>
            </div>
          </v-card-text>
        </v-tab-item>
        <v-tab-item value="tab-3">
          <div class="px-4">
            <h5 class="mt-3"><b> Livestream Details</b></h5>
            <div class="mt-4">
              <span class="h1_tab2"
                >Is this a Livestream course? (aired Live through Livestream
                platform)
              </span>

              <v-radio-group v-model="form.LivestreamCourse" row>
                <v-radio value="true" class="d-flex">
                  <template v-slot:label>
                    <span class="mt-2">Yes</span>
                  </template>
                </v-radio>
                <v-radio value="false">
                  <template v-slot:label>
                    <span class="mt-2">No</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>
            <div>
              <div class="my-4">
                <span><b> If yes, enter these details: </b></span>
              </div>
              <v-row>
                <v-col cols="12" md="4">
                  <v-row>
                    <v-col cols="12" md="6">
                      <span> Start Date </span>
                      <div class="my-3">
                        <v-menu
                          ref="LiveStreamStartDate"
                          v-model="LiveStreamStartDate"
                          :close-on-content-click="false"
                          :return-value.sync="form.LivestreamStartDate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              single-line
                              hide-details=""
                              v-model="form.LivestreamStartDate"
                              label=""
                              append-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="form.LivestreamStartDate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="LiveStreamStartDate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="
                                $refs.LiveStreamStartDate.save(
                                  form.LivestreamStartDate
                                )
                              "
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span> End Date </span>
                      <div class="my-3">
                        <v-menu
                          ref="LivestreamEndDate"
                          v-model="LivestreamEndDate"
                          :close-on-content-click="false"
                          :return-value.sync="form.LivestreamEndDate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              single-line
                              hide-details=""
                              v-model="form.LivestreamEndDate"
                              label=""
                              append-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="form.LivestreamEndDate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="LivestreamEndDate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="
                                $refs.LivestreamEndDate.save(
                                  form.LivestreamEndDate
                                )
                              "
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            <div class="my-3">
              <span>
                <span style="color: red">
                  KEEP THIS NOTE HERE FOR NOW:<br
                /></span>
                PENDING ROOTPOINTERS/IBA DISCUSSION - DEPENDS ON WHICH
                LIVESTREAM PLATFORM IS USED, WE DON’T KNOW WHAT OTHER DETAILS
                NEED TO BE ADDED HERE
              </span>
              <div>
                <v-text-field dense> </v-text-field>
              </div>
            </div>
            <div class="my-4">
              <span class="text_style"> Course Organization </span>
              <div class="my-3">
                <span>
                  Every event must have at least one Session (top-level
                  category) and one Part (can contain text, video, and/or
                  handouts).
                </span>
              </div>
            </div>
            <div class="my-3">
              <span class="text_style"> Sessions </span>
              <div>
                <v-row>
                  <v-col cols="12" md="5">
                    <table style="width: 100%">
                      <tr>
                        <th>Sequence <span class="pl-10"> </span></th>
                        <th>Session Name</th>
                        <th>Number Of Parts</th>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>Day 1</td>
                        <td>4</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Day 2</td>
                        <td>2</td>
                      </tr>
                    </table>
                  </v-col>
                </v-row>
              </div>
            </div>
            <div>
              <v-btn
                text
                color="primary"
                class="text_trsn"
                @click="AddSessionDialog = true"
              >
                + Add Session
              </v-btn>
            </div>
            <div class="my-5">
              <div class="py-3">
                <span class="text_style"><b> Parts </b></span>
              </div>
              <div>
                <v-row>
                  <v-col cols="12" md="8">
                    <table style="width: 100%">
                      <tr>
                        <th>In Session #</th>
                        <th>Sequence</th>
                        <th>part Name</th>
                        <th>video</th>
                        <th>Handouts</th>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>1</td>
                        <td>Part1</td>
                        <td>Study-Group-LS1.mp4</td>
                        <td>2</td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>2</td>
                        <td>Part1</td>
                        <td>Study-Group-LS1.mp4</td>
                        <td>0</td>
                      </tr>
                    </table>
                  </v-col>
                </v-row>
              </div>
              <div>
                <v-btn
                  link
                  text
                  color="primary"
                  class="text_trsn"
                  @click="AddPartDialog = true"
                >
                  + Add Part
                </v-btn>
              </div>
            </div>
            <v-dialog v-model="AddSessionDialog" persistent max-width="400">
              <v-card>
                <div class="pa-5 pb-0">
                  <div class="d-flex justify-space-between">
                    <div>
                      <span class="text_style"><b>Add Session</b> </span>
                    </div>
                    <div class="">
                      <v-icon @click="AddSessionDialog = false">
                        mdi-close
                      </v-icon>
                    </div>
                  </div>
                </div>
                <div class="pa-5">
                  <span>
                    <b>Set Sequence</b>
                  </span>
                  <div class="my-3">
                    <v-text-field
                      dense
                      outlined
                      single-line
                      v-model="SessionForm.SetSequenceForSession"
                      hide-details=""
                      label=""
                    >
                    </v-text-field>
                  </div>
                  <span>
                    <b> Set Session Name </b>
                  </span>
                  <div class="my-3">
                    <v-text-field
                      dense
                      outlined
                      single-line
                      v-model="SessionForm.SetSessionName"
                      hide-details=""
                      label=""
                    >
                    </v-text-field>
                  </div>
                </div>

                <v-card-actions class="pa-5">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="gray darken-1"
                    text
                    @click="AddSessionDialog = false"
                    depressed
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="AddSessionDialog = false"
                    depressed
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="AddPartDialog" persistent max-width="700">
              <v-card>
                <div class="pa-10 pb-0">
                  <div class="d-flex justify-space-between">
                    <div>
                      <span class="text_style"><b>Add Parts</b> </span>
                    </div>
                    <div class="">
                      <v-icon @click="AddPartDialog = false">
                        mdi-close
                      </v-icon>
                    </div>
                  </div>
                </div>
                <div class="pa-10 pt-0">
                  <div>
                    <v-row>
                      <v-col cols="12" md="6">
                        <div class="py-4">
                          <span>Select Session this Part belongs to: </span>
                        </div>
                        <div>
                          <v-select
                            dense
                            outlined
                            single-line
                            v-model="PartSessionForm.SessionId"
                            hide-details=""
                            label="Session 1"
                          >
                          </v-select>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6">
                        <div class="pb-4">
                          <span>Set Part name </span>
                        </div>
                        <div>
                          <v-text-field
                            dense
                            outlined
                            single-line
                            v-model="PartSessionForm.SetPartName"
                            hide-details=""
                            label="[part 1 other name]"
                          >
                          </v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6">
                        <div class="pb-4">
                          <span>Set Sequence within Session </span>
                        </div>
                        <div>
                          <v-text-field
                            dense
                            outlined
                            single-line
                            hide-details=""
                            v-model="PartSessionForm.SetSequence"
                            label="1"
                          >
                          </v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <div class="pb-4">
                        <span>Add Course Text(optional) </span>
                      </div>
                      <v-col cols="12">
                        <div>
                          <vue-editor
                            v-model="PartSessionForm.CourseText"
                          ></vue-editor>
                        </div>
                      </v-col>
                    </v-row>
                    <div class="my-6">
                      <span
                        >Add video (URL or Upload or Retrieve)(Optional)
                      </span>
                    </div>
                    <v-row>
                      <v-col cols="12" md="6">
                        <div>
                          <v-text-field
                            v-if="!PartSessionForm.VideoSrc"
                            dense
                            outlined
                            single-line
                            hide-details=""
                            label="[video URL, find or name?]"
                            prepend-icon=""
                          >
                          </v-text-field>
                          <video
                            style="width: 100%"
                            height="200"
                            v-else
                            dense
                            controls
                            outlined
                            :src="PartSessionForm.VideoSrc"
                            ref="UrlUploadFile"
                          ></video>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="d-flex align-center">
                          <v-icon
                            class="mt-2"
                            color="red"
                            @click="
                              deleteSrc((PartSessionForm.VideoSrc = null))
                            "
                            >mdi-delete
                          </v-icon>
                          <div class="upload-btn-wrapper">
                            <v-btn
                              color="primary"
                              class="ml-6"
                              @click="UploadImg"
                              >Upload</v-btn
                            >
                            <input
                              type="file"
                              style="display: none"
                              ref="RefPartSessionFormVideoSrc"
                              accept="video/mp4,video/x-m4v,video/*"
                              @change="SetImage"
                            />
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <div class="mt-3 mb-1">
                        <span
                          >Video thumbnail image (1920 x 1080px) (required if
                          video was added)
                        </span>
                      </div>
                      <v-col cols="12" md="6">
                        <div>
                          <v-file-input
                            dense
                            outlined
                            single-line
                            v-model="PartSessionForm.ThumbnailImage"
                            hide-details=""
                            label="Upload/Replace"
                            prepend-icon=""
                          >
                          </v-file-input>
                        </div>
                      </v-col>
                    </v-row>

                    <div class="mt-3 mb-1">
                      <span>Digital handout(s) (optional) </span>
                    </div>
                    <v-row class="my-2">
                      <v-col cols="12" md="6">
                        <div>
                          <v-text-field
                            dense
                            outlined
                            single-line
                            hide-details=""
                            label="[Upload]"
                            prepend-icon=""
                          >
                          </v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="12" md="1">
                        <div class="d-flex justify-space-between">
                          <v-icon class="mt-2" color="red">mdi-delete </v-icon>
                        </div>
                      </v-col>
                    </v-row>
                    <div
                      v-for="(div, index) in divs"
                      :key="div.id"
                      :div="(div = index)"
                    >
                      <v-row class="my-2">
                        <v-col cols="12" md="6">
                          <div>
                            <v-text-field
                              dense
                              outlined
                              single-line
                              hide-details=""
                              label="[Upload]"
                              prepend-icon=""
                            >
                            </v-text-field>
                          </div>
                        </v-col>
                        <v-col cols="12" md="1">
                          <div class="d-flex justify-space-between">
                            <v-icon
                              class="mt-2"
                              color="red"
                              dark
                              @click="DeleteAnotherHandout(index)"
                              >mdi-delete
                            </v-icon>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                    <div>
                      <v-btn
                        text
                        color="primary"
                        class="text-trans"
                        @click="AddAnotherHandout"
                        >+ Add another handout
                      </v-btn>
                    </div>
                  </div>
                </div>

                <v-card-actions class="pa-10">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="gray darken-1"
                    text
                    @click="AddPartDialog = false"
                    depressed
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    class="px-10 py-5"
                    color="primary"
                    @click="AddPartDialog = false"
                    depressed
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </v-tab-item>
        <v-tab-item value="tab-4">
          <div>
            <div class="my-6">
              <span>
                If an Instructor who created this course receives royalties for
                it, add the details here:
              </span>
            </div>
            <v-row>
              <v-col cols="12" md="8">
                <v-row>
                  <v-col cols="12" md="5">
                    <div class="">
                      <span><b> Add Instructor </b> </span>
                    </div>
                    <div class="mt-3">
                      <v-select dense outlined single-line hide-details=" ">
                      </v-select>
                    </div>
                  </v-col>
                  <v-col cols="12" md="5">
                    <div class="">
                      <span><b> Royalties rate per purchase </b> </span>
                    </div>
                    <div class="mt-3">
                      <v-text-field dense outlined single-line hide-details="">
                      </v-text-field>
                    </div>
                    <div class="d-flex justify-center">
                      <div class="mt-5">
                        <span class="pa-3">Flat Rate </span>
                      </div>
                      <v-switch
                        color="primary"
                        value
                        input-value="true"
                      ></v-switch>
                      <div class="mt-5">
                        <span class="pa-3">Percentage </span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="1">
                    <div class="d-flex justify-space-between">
                      <v-icon class="mt-11" color="red">mdi-delete </v-icon>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div
              v-for="(div, index) in divs"
              :key="div.id"
              :div="(div = index)"
            >
              <v-row>
                <v-col cols="12" md="8">
                  <v-row>
                    <v-col cols="12" md="5">
                      <div class="">
                        <span><b> Add Instructor </b> </span>
                      </div>
                      <div class="mt-3">
                        <v-select
                          dense
                          outlined
                          v-model="form.RoyaltyIntructor"
                          single-line
                          hide-details=" "
                        >
                        </v-select>
                      </div>
                    </v-col>
                    <v-col cols="12" md="5">
                      <div class="">
                        <span><b> Royalties rate per purchase </b> </span>
                      </div>
                      <div class="mt-3">
                        <v-text-field
                          dense
                          outlined
                          single-line
                          hide-details=""
                        >
                        </v-text-field>
                      </div>
                      <div class="d-flex justify-center">
                        <div class="mt-5">
                          <span class="pa-3">Flat Rate </span>
                        </div>
                        <v-switch
                          color="primary"
                          value
                          input-value="true"
                        ></v-switch>
                        <div class="mt-5">
                          <span class="pa-3">Percentage </span>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" md="1">
                      <div class="d-flex justify-space-between">
                        <v-icon
                          class="mt-11"
                          color="red"
                          @click="deleteRoyaltiesIntructor(index)"
                          >mdi-delete
                        </v-icon>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            <div>
              <v-btn class="text_trans" text color="primary" @click="addRow">
                + Add another Instructor
              </v-btn>
            </div>
            <div class="mt-5">
              <span
                >Send royalty payment directly to Instructor after purchase?
              </span>
              <div>
                <v-radio-group
                  v-model="form.SendRoyaltyPaymentDirect"
                  mandatory
                  row
                >
                  <v-radio label="Yes" value="true"></v-radio>
                  <v-radio label="No" value="false"></v-radio>
                </v-radio-group>
              </div>
            </div>
            <div class="">
              <span
                >Email the Instructor the student’s first name and email address
                on purchase?
              </span>
              <div>
                <v-radio-group v-model="form.RoyaltyEmailSend" mandatory row>
                  <v-radio label="Yes" value="true"></v-radio>
                  <v-radio label="No" value="false"></v-radio>
                </v-radio-group>
              </div>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item value="tab-5">
          <PreviewNewParamaCourseComponent></PreviewNewParamaCourseComponent>
        </v-tab-item>
      </v-tabs>
    </div>
    <v-divider class="my-6"></v-divider>
    <v-card flat class="d-flex justify-end mb-9">
      <v-btn
        outlined
        style="border: thin solid rgba(8, 8, 22, 0.15)"
        class="px-9 py-2 mx-9 text_style"
        >Save Draft</v-btn
      >
      <v-btn
        color="primary"
        class="px-9 py-2 text_style"
        @click="changeTab()"
        v-if="continuebtn == true"
        >Continue</v-btn
      >
      <v-btn
        color="primary"
        class="px-9 py-2 text_style"
        v-if="continuebtn == false"
        @click="send()"
      >
        <span v-if="btnloader != true"> Publish now </span>
        <v-progress-circular
          indeterminate
          size="20"
          class="px-5"
          color="white"
          v-show="btnloader"
        ></v-progress-circular>
      </v-btn>
    </v-card>
  </div>
</template>

<script>
import BlogimageuploaderComponent from "./blogimageuploader.component.vue";
//import BlogtextediterComponent from "./blogtextediter.component.vue";
import PreviewNewParamaCourseComponent from "./previewnewparamacourse.component.vue";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import BlogtextediterComponent from "../blogtextediter.component.vue";
import CameraBorderBoxSvg from "../../../assets/SvgIcons/CameraborderboxSvg.vue";
import { VueEditor } from "vue2-editor";

export default {
  components: {
    BlogimageuploaderComponent,
    BlogtextediterComponent,
    PreviewNewParamaCourseComponent,
    CameraBorderBoxSvg,
    VueEditor,
  },
  name: "NewParamaCourseComponent",

  computed: {
    ...mapGetters(["GetLoggedInUser"]),
  },
  mounted() {
    this.form.SubmittedBy = this.GetLoggedInUser.Username;
  },

  data() {
    return {
      AddSessionDialog: false,
      AddPartDialog: false,
      prerequisites: false,
      prerequisitescourses: true,
      SeeSecondInstructor: false,
      SeePrimaryTranslator: false,
      SeeSecondTranslator: false,
      MemberArray: "",
      svgBackground2: true,
      UploadedImage2: false,
      img2: {},
      //InstructorImage: null,
      svgBackground3: true,
      UploadedImage3: false,
      img3: {},
      Src3: null,
      svgBackground4: true,
      UploadedImage4: false,
      img4: {},
      Src4: null,
      svgBackground5: true,
      UploadedImage5: false,
      img5: {},
      Src5: null,

      div: 0,
      divs: [],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      Selection: false,
      radioSelection: false,
      selectedFile: null,
      FreeCourseCheckBox: true,
      chip1: false,
      isSelecting: false,
      isSelecting2: false,
      UploadedfileName: [],
      UploadedfileNametwo: [],
      prerequisitesDialog: false,
      items: "",
      btnloader: false,
      Rcontentdialog: false,
      continuebtn: true,
      tab: "tab-1",
      chipsvalue: null,
      chips: [],
      CourseInstructorArray: ["Alex"],
      CurrencyTypeArray: ["USD"],
      CurrencyType: "USD",
      CourseInstructor: "Alex",
      CourseTranslatorArray: ["Alex"],
      CourseTranslator: "Alex",
      expireDuration: "Yes, this course expirates after 365 days",
      expireDurationArray: [
        "Yes, this course expirates after 365 days",
        "No, this course has no expiration date.",
      ],
      selection: 1,
      selectedLanguage: "English",
      LanguageArray: [
        "English",
        "French",
        "German",
        "Japanese",
        "Italian",
        "Portuguese",
        "Filipino",
        "Spanish",
        "Chinese",
        "Russian",
      ],
      selectedLevel: "Beginner",
      LevelsArray: [
        "Beginner (default)",
        "Entry-Level Training",
        "Intermediate",
        "Advanced",
        "Very Advanced Training",
      ],
      VisibilityArray: ["1", "2"],
      permissionsArray: [
        "Free",
        "Access",
        "Life Science ",
        "Standard ",
        "Practitioner",
        "Instructor",
      ],
      visible: ["Hide", "Show"],
      filterCategory: [],
      filterCategoryArray: [
        "Anatomy and Physiology",
        "AnimalTalk",
        "BodyTalk Access",
        "BodyTalk Courses",
        "BreakThrough",
        "CEUs",
        "Conferences",
        "Courses LS",
        "FREE Courses",
        "FSI",
        "Group Sessions",
      ],
      form: {
        Title: "",
        subHeading: "",
        Thumbnail: null,
        Image1: null,
        Image2: null,
        Image3: null,
        Banner: null,
        Content: "",
        filterCategory: [],
        CourseDescription: "",
        InstructorName: "",
        InstructorImage: null,
        InstructorBio: "",
        CourseStartDate: null,
        CourseFee: [],
        selectedPermissions: [],
        CEUs: "",
        DisplayOrder: "",
        level: "",
        selectedLanguage: "",
        FeeAccountCreation: false,
        AfterPurchaseDate: false,
        Currency: "",
        coursePrice: "",
        FreeCourseCheckBox: false,
        VideoUrl: "",
        PrerequisitesCourseOne: null,
        PrerequisitesCoursetwo: null,
        PrerequisitesCoursethree: null,
        PrerequisitesCoursefour: null,
        UploadedfileName: [],
        UploadedfileNametwo: [],
        LivestreamCourse: false,
        LivestreamStartDate: null,
        LivestreamEndDate: null,
        RoyaltyEmailSend: null,
        SendRoyaltyPaymentDirect: null,
        RoyaltyIntructor: "",
        SubmittedBy: "",
      },
      SessionForm: {
        SetSessionName: "",
        SetSequenceForSession: null,
      },
      PartSessionForm: {
        SessionId: null,
        SetPartName: "",
        CourseText: "",
        SetSequence: null,
        VideoSrc: null,
        ThumbnailImage: null,
      },

      relatedContentArray: [
        {
          img: "https://cdn.vuetifyjs.com/images/cards/cooking.png",
          title: "Lorem ipsum dolor sit amet consectetur adropising",
          desc: "September 23, 2021",
        },
        {
          img: "https://cdn.vuetifyjs.com/images/cards/cooking.png",
          title: "Lorem ipsum dolor sit amet consectetur adropising",
          desc: "September 23, 2021",
        },
        {
          img: "https://cdn.vuetifyjs.com/images/cards/cooking.png",
          title: "Lorem ipsum dolor sit amet consectetur adropising",
          desc: "September 23, 2021",
        },
      ],
    };
  },
  validations: {
    form: {
      Title: {
        required,
      },
      subHeading: {
        required,
      },
      Banner: { required },
      Thumbnail: {
        required,
      },
      // Content: {
      //   required,
      // },
    },
  },
  methods: {
    send() {
      var Form = new FormData();
      Form.append("Title", this.form.Title);
      Form.append("SubDescription", this.form.subHeading);

      Form.append("Banner", this.form.Banner);

      Form.append("Thumbnail", this.form.Thumbnail);
    },
    Showprerequisites() {
      this.prerequisites = true;
      this.prerequisitescourses = false;
    },
    UploadInstructorImage() {
      this.$refs.RefInstructorImage.click();
    },
    SetInstructorImage() {
      var reader = new FileReader();
      reader.onload = () => {
        this.form.InstructorImage = reader.result;
        this.$refs.RefInstructorImage.src = reader.result;
      };
      // this.$emit("SetBanner", this.$refs.Img.files[0]);
      reader.readAsDataURL(this.$refs.RefInstructorImage.files[0]);
    },
    UploadImgthree() {
      this.$refs.Img3.click();
    },
    SetImagethree() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src3 = reader.result;
        this.$refs.Image3.src = reader.result;
      };
      // this.$emit("SetBanner", this.$refs.Img.files[0]);
      reader.readAsDataURL(this.$refs.Img3.files[0]);
    },
    UploadImgfour() {
      this.$refs.Img4.click();
    },
    SetImagefour() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src4 = reader.result;
        this.$refs.Image4.src = reader.result;
      };
      // this.$emit("SetBanner", this.$refs.Img.files[0]);
      reader.readAsDataURL(this.$refs.Img4.files[0]);
    },
    UploadImg5() {
      this.$refs.Img5.click();
    },
    SetImage5() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src5 = reader.result;
        this.$refs.Image5.src = reader.result;
      };
      // this.$emit("SetBanner", this.$refs.Img.files[0]);
      reader.readAsDataURL(this.$refs.Img5.files[0]);
    },
    addRow() {
      this.divs.push({
        div: this.div,
      });
    },
    RemoveRowMembershipDiscount() {
      this.divs.pop({
        div: this.div,
      });
    },
    deleteRoyaltiesIntructor() {
      this.divs.pop({
        div: this.div,
      });
    },
    closechip(index) {
      var list = [];
      for (var i = 0; i < this.UploadedfileName.length; i++) {
        if (i != index) {
          list.push(this.UploadedfileName[i]);
        }
      }
      this.UploadedfileName = list;
    },
    closechip2(index) {
      var list = [];
      for (var i = 0; i < this.UploadedfileNametwo.length; i++) {
        if (i != index) {
          list.push(this.UploadedfileNametwo[i]);
        }
      }
      this.UploadedfileNametwo = list;
    },
    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    onButtonClick2() {
      this.isSelecting2 = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting2 = false;
        },
        { once: true }
      );

      this.$refs.uploader2.click();
    },
    onFileChanged(e) {
      this.chip1 = true;
      if (e.target.files.length > 0) {
        for (var i = 0; i < e.target.files.length; i++) {
          this.UploadedfileName.push(e.target.files[i]);
        }
        e.target.value = "";
      }
    },
    onFileChanged2(e) {
      this.chip1 = true;
      if (e.target.files.length > 0) {
        for (var i = 0; i < e.target.files.length; i++) {
          this.UploadedfileNametwo.push(e.target.files[i]);
        }
        e.target.value = "";
      }
    },
    RelatedContentSend() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.Rcontentdialog = false;
        this.btnloader = false;
      }, 2000);
    },
    close(index) {
      this.relatedContentArray.splice(
        this.relatedContentArray.indexOf(index),
        1
      );
    },

    reserve() {
      this.loading = true;
      setTimeout(() => (this.loading = false), 2000);
    },
    remove(item) {
      this.chips.splice(this.chips.indexOf(item), 1);
      this.chips = [...this.chips];
    },
    UploadImg() {
      this.$refs.RefPartSessionFormVideoSrc.click();
    },
    SetImage() {
      var reader = new FileReader();
      reader.onload = () => {
        this.PartSessionForm.VideoSrc = reader.result;
        // this.$refs.FileReader.src = reader.result;
      };
      reader.readAsDataURL(this.$refs.RefPartSessionFormVideoSrc.files[0]);
    },
    AddAnotherHandout() {
      this.divs.push({
        div: this.div,
      });
    },
    DeleteAnotherHandout(index) {
      this.divs.splice(index, 1);
    },
    changeTab() {
      if (this.tab == "tab-1") {
        this.$v.form.Title.$touch();
        this.$v.form.subHeading.$touch();
        this.$v.form.Banner.$touch();
        this.$v.form.filterCategory.$touch();
        // this.$v.form.Content.$touch();
        // this.$v.form.Content.$invalid
        if (
          this.$v.form.Title.$invalid &&
          this.$v.form.subHeading.$invalid &&
          this.$v.form.Banner.$invalid &&
          this.$v.form.filterCategory.$invalid
        ) {
          this.submitStatus = "ERROR";
        } else {
          // var obj = {
          //   title: this.form.Title,
          //   subHeading: this.form.subHeading,
          //   banner: this.form.Banner,
          //   content: this.form.Content,
          //   filterCategory: this.form.filterCategory,
          // }; 
        }
      } else if (this.tab == "tab-2") {
        this.tab = "tab-3";
      } else if (this.tab == "tab-3") {
        this.tab = "tab-4";
      } else {
        this.tab = "tab-5";
        this.continuebtn = false;
      }
    },
    CourseDescription(content) {
      this.form.CourseDescription = content;
    },
    SetBanner(banner) {
      this.form.Banner = banner;
    },
    SetThumbnail(thumbnail) {
      this.form.Thumbnail = thumbnail;
    },
    SetImage1(image1) {
      this.form.Image1 = image1;
    },
    SetImage2(image2) {
      this.form.Image2 = image2;
    },
    SetImage3(image3) {
      this.form.Image3 = image3;
    },
    SetInstructorBio(content) {
      this.form.InstructorBio = content;
    },
  },
};
</script>

<style scoped>
h1 {
  font-family: "Noto Serif";
  font-size: 40px;
  font-weight: 700;
  line-height: 54px;
  letter-spacing: 0em;
  text-align: left;
  color: #222222;
}
.tabs_style {
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0em;
}
a:hover {
  text-decoration: none;
}
.v-tabs-slider {
  background-color: white !important;
}
.h1_tab2 {
  font-family: "DM Sans";
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
}
.content_span {
  font-family: " DM Sans";
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
}
.content_date {
  font-family: "DM Sans";
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: rgba(8, 8, 22, 0.38);
}
.content_chip {
  font-family: "DM Sans";
  font-size: 10px;
  font-weight: 400;
  line-height: 13px;
  color: #54be5a;
}
.text_trans {
  text-transform: none;
}
#no-background-hover::before {
  background-color: transparent !important;
}
@media screen and (max-width: 750px) {
  h1 {
    font-size: 23px;
  }
}
@media screen and (max-width: 430px) {
  .v-application .mx-14 {
    margin-right: 20px !important;
    margin-left: 10px !important;
  }
}
</style>
